import { call, put } from "redux-saga/effects";
import * as types from "../consts";
import { postSetPassword } from "../api";

export function* postSetPasswordRequestSaga({
  payload,
}: ReturnType<typeof Object>) {
  try {
    const setPassword: object = yield call(postSetPassword, payload);
    if (setPassword) {
      yield put({ type: types.POST_SET_PASSWORD_SUCCESS, setPassword });
    } else {
      yield put({ type: types.POST_SET_PASSWORD_ERROR});
    }
  } catch (error) {
    yield put({ type: types.POST_SET_PASSWORD_ERROR, error });
  }
}
